// Authentication Endpoints
export const AUTH_ENDPOINTS = {
  REGISTER: "/auth/signup",
  LOGIN: "/post-jwt-login",
  PASSWORD_FORGET: "/auth/forgot-password",
  JWT_PASSWORD_FORGET: "/jwt-forget-pwd",
  SOCIAL_LOGIN: "/social-login",
  EDIT_PROFILE: "/post-jwt-profile",
  EDIT_USER_PROFILE: "/user",
};

// Calendar Endpoints
export const CALENDAR_ENDPOINTS = {
  GET_EVENTS: "/events",
  GET_CATEGORIES: "/categories",
  GET_UPCOMMINGEVENT: "/upcommingevents",
  ADD_NEW_EVENT: "/add/event",
  UPDATE_EVENT: "/update/event",
  DELETE_EVENT: "/delete/event",
};

// Chat Endpoints
export const CHAT_ENDPOINTS = {
  GET_DIRECT_CONTACT: "/chat",
  GET_MESSAGES: "/messages",
  ADD_MESSAGE: "add/message",
  GET_CHANNELS: "/channels",
  DELETE_MESSAGE: "delete/message",
};

// Mailbox Endpoints
export const MAILBOX_ENDPOINTS = {
  GET_MAIL_DETAILS: "/mail",
  DELETE_MAIL: "/delete/mail",
};

// Dashboard Stats (real data from backend)
export const DASHBOARD_STATS = "/dashboard/stats";
export const DASHBOARD_REVENUE_CHART = "/dashboard/revenue-chart";
export const DASHBOARD_BEST_SELLING = "/dashboard/best-selling-products";
export const DASHBOARD_NEW_SELLERS = "/dashboard/new-sellers";

// Ecommerce Endpoints
export const ECOMMERCE_ENDPOINTS = {
  // Product
  GET_PRODUCTS: "/products",
  DELETE_PRODUCT: "/products",
  ADD_NEW_PRODUCT: "/products",
  UPDATE_PRODUCT: "/products",
  // Orders
  GET_ORDERS: "/orders",
  GET_ORDER: "/orders",
  ADD_NEW_ORDER: "/orders",
  UPDATE_ORDER: "/orders",
  DELETE_ORDER: "/orders",
  // Settings (Stripe keys)
  GET_SETTINGS: "/settings",
  UPDATE_SETTING: "/settings",
  // Customers
  GET_CUSTOMERS: "/apps/customer",
  ADD_NEW_CUSTOMER: "/apps/customer",
  UPDATE_CUSTOMER: "/apps/customer",
  DELETE_CUSTOMER: "/apps/customer",
  // Sellers
  GET_SELLERS: "/sellers",
  GET_SELLER: "/sellers",
  GET_SELLER_ME: "/sellers/me",
  // Seller withdrawals (vendor payout requests)
  SELLER_WITHDRAWALS: "/seller-withdrawals",
  ADD_NEW_SELLER: "/sellers",
  UPDATE_SELLER: "/sellers",
  DELETE_SELLER: "/sellers",
  SUSPEND_SELLER: "/sellers",
  // Categories
  GET_CATEGORIES: "/categories",
  ADD_NEW_CATEGORY: "/categories",
  UPDATE_CATEGORY: "/categories",
  DELETE_CATEGORY: "/categories",
  // Subcategories
  GET_SUBCATEGORIES: "/subcategories",
  ADD_NEW_SUBCATEGORY: "/subcategories",
  UPDATE_SUBCATEGORY: "/subcategories",
  DELETE_SUBCATEGORY: "/subcategories",
  // Product Attributes
  GET_ATTRIBUTES: "/product-attributes",
  ADD_NEW_ATTRIBUTE: "/product-attributes",
  UPDATE_ATTRIBUTE: "/product-attributes",
  DELETE_ATTRIBUTE: "/product-attributes",
  // Commissions
  GET_COMMISSIONS: "/commissions",
  ADD_NEW_COMMISSION: "/commissions",
  UPDATE_COMMISSION: "/commissions",
  DELETE_COMMISSION: "/commissions",
  // Taxes
  GET_TAXES: "/taxes",
  ADD_NEW_TAX: "/taxes",
  UPDATE_TAX: "/taxes",
  DELETE_TAX: "/taxes",
  // Product Reviews
  GET_PRODUCT_REVIEWS: "/product-reviews",
  ADD_PRODUCT_REVIEW: "/product-reviews",
  DELETE_PRODUCT_REVIEW: "/product-reviews",
  // Home Banners (website home page)
  GET_HOME_BANNERS: "/home-banners",
  ADD_HOME_BANNER: "/home-banners",
  DELETE_HOME_BANNER: "/home-banners",
  GET_HOME_AD_BANNERS: "/home-ad-banners",
  ADD_HOME_AD_BANNER: "/home-ad-banners",
  DELETE_HOME_AD_BANNER: "/home-ad-banners",
  // Footer Ad Banners
  GET_FOOTER_AD_BANNERS: "/footer-ad-banners",
  ADD_FOOTER_AD_BANNER: "/footer-ad-banners",
  DELETE_FOOTER_AD_BANNER: "/footer-ad-banners",
  UPDATE_FOOTER_AD_BANNER: "/footer-ad-banners",
  // Best Selling Ad Banners
  GET_BEST_SELLING_AD_BANNERS: "/best-selling-ad-banners",
  ADD_BEST_SELLING_AD_BANNER: "/best-selling-ad-banners",
  DELETE_BEST_SELLING_AD_BANNER: "/best-selling-ad-banners",
  UPDATE_BEST_SELLING_AD_BANNER: "/best-selling-ad-banners",
};

// Project Endpoints
export const PROJECT_ENDPOINTS = {
  GET_PROJECT_LIST: "/project/list",
  ADD_NEW_PROJECT: "/add/project",
  UPDATE_PROJECT: "/update/project",
  DELETE_PROJECT: "/delete/project",
};

// Task Endpoints
export const TASK_ENDPOINTS = {
  GET_TASK_LIST: "/apps/task",
  ADD_NEW_TASK: "/apps/task",
  UPDATE_TASK: "/apps/task",
  DELETE_TASK: "/apps/task",
  GET_TASKS: "/apps/tasks",
  ADD_TASKS: "/add/tasks",
  UPDATE_TASKS: "/update/tasks",
  DELETE_TASKS: "/delete/tasks",
};

// CRM Endpoints
export const CRM_ENDPOINTS = {
  // Contact
  GET_CONTACTS: "/apps/contact",
  ADD_NEW_CONTACT: "/apps/contact",
  UPDATE_CONTACT: "/apps/contact",
  DELETE_CONTACT: "/apps/contact",
  // Companies
  GET_COMPANIES: "/apps/company",
  ADD_NEW_COMPANIES: "/apps/company",
  UPDATE_COMPANIES: "/apps/company",
  DELETE_COMPANIES: "/apps/company",
  // Lead
  GET_LEADS: "/apps/lead",
  ADD_NEW_LEAD: "/apps/lead",
  UPDATE_LEAD: "/apps/lead",
  DELETE_LEAD: "/apps/lead",
  // Deals
  GET_DEALS: "/deals",
};

// Crypto Endpoints
export const CRYPTO_ENDPOINTS = {
  GET_TRANSACTION_LIST: "/transaction-list",
  GET_ORDRER_LIST: "/order-list",
};

// Invoice Endpoints
export const INVOICE_ENDPOINTS = {
  GET_INVOICES: "/apps/invoice",
  ADD_NEW_INVOICE: "/apps/invoice",
  UPDATE_INVOICE: "/apps/invoice",
  DELETE_INVOICE: "/apps/invoice",
};

// Support Tickets Endpoints
export const TICKETS_ENDPOINTS = {
  GET_TICKETS_LIST: "/apps/ticket",
  ADD_NEW_TICKET: "/apps/ticket",
  UPDATE_TICKET: "/apps/ticket",
  DELETE_TICKET: "/apps/ticket",
};

// Dashboard Analytics Endpoints
export const DASHBOARD_ANALYTICS_ENDPOINTS = {
  // Sessions by Countries
  GET_ALL_DATA: "/all-data",
  GET_HALFYEARLY_DATA: "/halfyearly-data",
  GET_MONTHLY_DATA: "/monthly-data",
  // Audiences Metrics
  GET_ALLAUDIENCESMETRICS_DATA: "/allAudiencesMetrics-data",
  GET_MONTHLYAUDIENCESMETRICS_DATA: "/monthlyAudiencesMetrics-data",
  GET_HALFYEARLYAUDIENCESMETRICS_DATA: "/halfyearlyAudiencesMetrics-data",
  GET_YEARLYAUDIENCESMETRICS_DATA: "/yearlyAudiencesMetrics-data",
  // Users by Device
  GET_TODAYDEVICE_DATA: "/todayDevice-data",
  GET_LASTWEEKDEVICE_DATA: "/lastWeekDevice-data",
  GET_LASTMONTHDEVICE_DATA: "/lastMonthDevice-data",
  GET_CURRENTYEARDEVICE_DATA: "/currentYearDevice-data",
  // Audiences Sessions by Country
  GET_TODAYSESSION_DATA: "/todaySession-data",
  GET_LASTWEEKSESSION_DATA: "/lastWeekSession-data",
  GET_LASTMONTHSESSION_DATA: "/lastMonthSession-data",
  GET_CURRENTYEARSESSION_DATA: "/currentYearSession-data",
};

// Dashboard CRM Endpoints
export const DASHBOARD_CRM_ENDPOINTS = {
  // Balance Overview
  GET_TODAYBALANCE_DATA: "/todayBalance-data",
  GET_LASTWEEKBALANCE_DATA: "/lastWeekBalance-data",
  GET_LASTMONTHBALANCE_DATA: "/lastMonthBalance-data",
  GET_CURRENTYEARBALANCE_DATA: "/currentYearBalance-data",
  // Deal type
  GET_TODAYDEAL_DATA: "/todayDeal-data",
  GET_WEEKLYDEAL_DATA: "/weeklyDeal-data",
  GET_MONTHLYDEAL_DATA: "/monthlyDeal-data",
  GET_YEARLYDEAL_DATA: "/yearlyDeal-data",
  // Sales Forecast
  GET_OCTSALES_DATA: "/octSales-data",
  GET_NOVSALES_DATA: "/novSales-data",
  GET_DECSALES_DATA: "/decSales-data",
  GET_JANSALES_DATA: "/janSales-data",
};

// Dashboard Ecommerce Endpoints
export const DASHBOARD_ECOMMERCE_ENDPOINTS = {
  // Revenue
  GET_ALLREVENUE_DATA: "/allRevenue-data",
  GET_MONTHREVENUE_DATA: "/monthRevenue-data",
  GET_HALFYEARREVENUE_DATA: "/halfYearRevenue-data",
  GET_YEARREVENUE_DATA: "/yearRevenue-data",
};

// Dashboard Crypto Endpoints
export const DASHBOARD_CRYPTO_ENDPOINTS = {
  // Portfolio
  GET_BTCPORTFOLIO_DATA: "/btcPortfolio-data",
  GET_USDPORTFOLIO_DATA: "/usdPortfolio-data",
  GET_EUROPORTFOLIO_DATA: "/euroPortfolio-data",
  // Market Graph
  GET_ALLMARKETDATA_DATA: "/allMarket-data",
  GET_YEARMARKET_DATA: "/yearMarket-data",
  GET_MONTHMARKET_DATA: "/monthMarket-data",
  GET_WEEKMARKET_DATA: "/weekMarket-data",
  GET_HOURMARKET_DATA: "/hourMarket-data",
};

// Dashboard Project Endpoints
export const DASHBOARD_PROJECT_ENDPOINTS = {
  // Project Overview
  GET_ALLPROJECT_DATA: "/allProject-data",
  GET_MONTHPROJECT_DATA: "/monthProject-data",
  GET_HALFYEARPROJECT_DATA: "/halfYearProject-data",
  GET_YEARPROJECT_DATA: "/yearProject-data",
  // Project Status
  GET_ALLPROJECTSTATUS_DATA: "/allProjectStatus-data",
  GET_WEEKPROJECTSTATUS_DATA: "/weekProjectStatus-data",
  GET_MONTHPROJECTSTATUS_DATA: "/monthProjectStatus-data",
  GET_QUARTERPROJECTSTATUS_DATA: "/quarterProjectStatus-data",
};

// Dashboard NFT Endpoints
export const DASHBOARD_NFT_ENDPOINTS = {
  // Marketplace
  GET_ALLMARKETPLACE_DATA: "/allMarketplace-data",
  GET_MONTHMARKETPLACE_DATA: "/monthMarketplace-data",
  GET_HALFYEARMARKETPLACE_DATA: "/halfYearMarketplace-data",
  GET_YEARMARKETPLACE_DATA: "/yearMarketplace-data",
};

// Team Endpoints
export const TEAM_ENDPOINTS = {
  GET_TEAMDATA: "/teamData",
  DELETE_TEAMDATA: "/delete/teamData",
  ADD_NEW_TEAMDATA: "/add/teamData",
  UPDATE_TEAMDATA: "/update/teamData",
};

// File Manager Endpoints
export const FILE_MANAGER_ENDPOINTS = {
  // Folder
  GET_FOLDERS: "/folder",
  DELETE_FOLDER: "/delete/folder",
  ADD_NEW_FOLDER: "/add/folder",
  UPDATE_FOLDER: "/update/folder",
  // File
  GET_FILES: "/file",
  DELETE_FILE: "/delete/file",
  ADD_NEW_FILE: "/add/file",
  UPDATE_FILE: "/update/file",
};

// Todo Endpoints
export const TODO_ENDPOINTS = {
  GET_TODOS: "/todo",
  DELETE_TODO: "/delete/todo",
  ADD_NEW_TODO: "/add/todo",
  UPDATE_TODO: "/update/todo",
  GET_PROJECTS: "/projects",
  ADD_NEW_TODO_PROJECT: "/add/project",
};

// Job Application Endpoints
export const JOB_ENDPOINTS = {
  GET_APPLICATION_LIST: "/application-list",
};

// API Key Endpoints
export const API_KEY_ENDPOINTS = {
  GET_API_KEY: "/api-key",
};

